import React from 'react'

export default function LeftArrow() {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.96199 0.34325L7.37299 1.76125L4.10299 5.01625L17.708 5.02925L17.706 7.02925L4.13799 7.01625L7.35299 10.2462L5.93599 11.6563L0.291992 5.98625L5.96199 0.34325Z" fill="#4F4A3E"/>
    </svg>
  )
}
